import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { AttendanceMergeService } from '../../../Model/AttendanceMerge/attendance-merge.service';
import { Subject } from 'rxjs';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';

@Component({
  selector: 'app-emp-attendance-merge',
  standalone: true,
  imports: [CommonModule, NgSelectModule, RouterModule, DataTablesModule, FormsModule, LoaderComponent],
  templateUrl: './emp-attendance-merge.component.html',
  styleUrl: './emp-attendance-merge.component.scss'
})
export class EmpAttendanceMergeComponent {
  isDisabled: boolean = false;
  TableDatas: any[] = [];
  user = [] as any;
  BranchMaster: any[] = [];
  ClientMaster: any[] = [];
  SiteMaster: any[] = [];

  Filter = {
    SelectType: 1,
    BranchID: null,
    ClientID: null,
    SiteID: null,
    EmpID: null,
    EmpType: null as any,
    EmpCode: null,
  }
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private tooltip: TooltipService,
    private session: SessionService,
    private router: Router,
    private toast: ToastService,
    private comboload: ComboService,
    private route: ActivatedRoute,
    private attendancemerge: AttendanceMergeService,
    private modalService: NgbModal,
  ) {
    // this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.Filter.EmpType = this.router.url.split('/')[3];
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client') ? this.Filter.BranchID : 0,
      'ClientId': (Combotype == 'Site') ? this.Filter.ClientID : 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.ClientMaster = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.SiteMaster = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false
      },
    });
  }

  Validate(form: any) {
    if (form.valid) {
      this.Load()
    }
    else {
      form.submitted = true;
    }
  }

  Load() {
    this.attendancemerge.GetEmployeeForAttendanceMergeFlag(this.Filter).subscribe({
      next: (response) => {
        if (response) {
          this.TableDatas = Object.values(response.Table);
          this.TableDatas.forEach((site) => {
            if (site.ESS_IsAttendanceMerge) {
              site.selected = true; // Check the checkbox if there's a FileNamelink
            } else {
              site.selected = false; // Make sure it's unchecked if there's no FileNamelink
            }
          });
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
        }
      },
      complete: () => { this.isDisabled = false },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onSelectChange(type: string) {
    if (type === 'Branch') {
      this.Filter.ClientID = null
      this.ClientMaster = [];
      this.Filter.SiteID = null
      this.SiteMaster = []
      this.TableDatas = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'Client') {
      this.Filter.SiteID = null
      this.SiteMaster = []
      this.TableDatas = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'Site') {
      this.TableDatas = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    }
  }
  selectAll(event: any) {
    const isChecked = event.target.checked;
    this.TableDatas.forEach((shift) => {
      shift.selected = isChecked;
    });
  }
  selectRow(event: any, shift: any) {
    shift.selected = event.target.checked;
  }

  Save() {
    //await this.common.getPageRights();
    //const selectedItems = this.TableDatas.filter(item => item.selected);
    // if (selectedItems.length === 0) {
    //   this.toast.show({ message: 'Please select at least 1 Employee!', type: toastTypeEnum.warning });
    //   return;
    // }
    // const empIDs = this.TableDatas.map(item => item['EmpMasterID']);
    // console.log(empIDs.join(', '));
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save?'
    modalRef.result.then(async (result: any) => {
      if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
        if (result) {
          this.isDisabled = true;
          const length = this.TableDatas.length;
          let index = 0;
          await this.TableDatas.forEach(async (element: any) => {
            await this.attendancemerge.AttendanceMergeFlag({ SelectType: 1, EmpmasterID: element.EmpMasterID, ESS_IsAttendanceMerge: element.selected }).subscribe({
              next: (data) => {
                index += 1;
                if (data.Error_Code == '695') {

                }
                else {
                  this.isDisabled = false;
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = data.Error_Message;
                  modalRef.result.then((result: any) => { });
                }
                if (index == length) {
                  this.isDisabled = false;
                  this.isDisabled = false
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = data.Error_Message;
                  modalRef.result.then((result: any) => {
                    if (result) {
                      this.Load()
                    }
                  });
                }
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            })
          })
          //let EmpMatserId = empIDs.join(', ');
          // const data = {
          //   SelectType: 1,
          //   EmpmasterID: '',//EmpMatserId,
          //   ESS_IsAttendanceMerge: true
          // }
          // console.log(data);
          // this.attendancemerge.AttendanceMergeFlag(data).subscribe({
          //   next: (data) => {
          //     if (data.Error_Code == '695') {
          //       this.isDisabled = false
          //       const modalRef = this.modalService.open(AlertSuccessComponent, {
          //         size: 'md',
          //         backdrop: 'static',
          //         centered: true,
          //         windowClass: 'confirmation-modal'
          //       });
          //       modalRef.componentInstance.Message = data.Error_Message;
          //       modalRef.result.then((result: any) => {
          //         if (result) {
          //           this.Load()
          //         }
          //       });
          //     }
          //     else {
          //       this.isDisabled = false;
          //       const modalRef = this.modalService.open(AlertWarningComponent, {
          //         size: 'md',
          //         backdrop: 'static',
          //         centered: true,
          //         windowClass: 'confirmation-modal'
          //       });
          //       modalRef.componentInstance.Message = data.Error_Message;
          //       modalRef.result.then((result: any) => { });
          //     }
          //     this.isDisabled = false;
          //   },
          //   complete: () => { },
          //   error: (error) => {
          //     this.isDisabled = false;
          //   },
          // });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
      // Modal dismissed
    });
  }
}
